import { render, staticRenderFns } from "./UserActivityRecordDialog.vue?vue&type=template&id=2017515f&scoped=true&lang=pug&"
import script from "./UserActivityRecordDialog.vue?vue&type=script&lang=ts&"
export * from "./UserActivityRecordDialog.vue?vue&type=script&lang=ts&"
import style0 from "./UserActivityRecordDialog.vue?vue&type=style&index=0&id=2017515f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2017515f",
  null
  
)

export default component.exports